// extracted by mini-css-extract-plugin
export default {"page":"result_page__1t8zn","text":"result_text__wlE2m","list":"result_list__c2F89","list-item":"result_list-item__bPzZP","subtitle":"result_subtitle__03AkW"};